// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let WizardFormValidation = require("./WizardFormValidation.bs.js");

function validateDate(date, id, timeZone) {
  if (id !== undefined) {
    return WizardFormValidation.requiredDate(date);
  } else {
    return WizardFormValidation.calendarDateOnOrAfterToday(date, timeZone);
  }
}

let validateEndTime = WizardFormValidation.endTimeAfterStartTime;

function validate(showing, timeZone) {
  return WizardFormValidation.allValid([
    WizardFormValidation.requiredOption(showing.type_),
    validateDate(showing.date, showing.id, timeZone),
    WizardFormValidation.endTimeAfterStartTime(showing.endTime, showing.startTime),
    WizardFormValidation.requiredTime(showing.startTime)
  ]);
}

function isEmpty(showing) {
  let match = showing.type_;
  let match$1 = showing.date;
  let match$2 = showing.endTime;
  let match$3 = showing.startTime;
  if (match !== undefined || match$1 !== undefined || match$2 !== undefined) {
    return false;
  } else {
    return match$3 === undefined;
  }
}

let validateType = WizardFormValidation.requiredOption;

let validateStartTime = WizardFormValidation.requiredTime;

exports.validateType = validateType;
exports.validateDate = validateDate;
exports.validateStartTime = validateStartTime;
exports.validateEndTime = validateEndTime;
exports.validate = validate;
exports.isEmpty = isEmpty;
/* WizardFormValidation Not a pure module */
